import { Stack } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../lib/hooks';
import { setDocumentStructure } from '../../lib/state/slices/ProjectStateSlice';
import { useState } from 'react';
import DocumentCard from '../DocumentCard';
import FolderSelector from '../FolderSelector';

export default function SavedDocumentsList() {
  const folders = useAppSelector((state) => state.viewReducer.documents.structure.FOLDER);
  const dispatch = useAppDispatch();
  const [openFolder, setOpenFolder] = useState<string | null>('default');

  return (
    <div
      style={{
        height: '100%',
        maxWidth: '420px',
        display: 'flex',
        flexDirection: 'column',
        padding: '10px',
        flexGrow: 1,
      }}
    >
      <FolderSelector onFolderOpen={setOpenFolder} />
      <Stack
        direction={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        padding={'10px'}
        overflowY={'auto'}
        overflowX={'hidden'}
        display={'grid'}
        gridAutoRows={'min-content'}
        height={'100%'}
        marginTop={'10px'}
        style={{
          scrollbarWidth: 'thin',
        }}
      >
        {openFolder
          ? Object.values(folders)
              .find((folder) => folder.id === openFolder)
              ?.documents.map((doc) => (
                <DocumentCard
                  key={doc}
                  id={doc}
                  nodeId=""
                  onClose={() => {
                    dispatch(
                      setDocumentStructure({
                        type: 'FOLDER',
                        key: openFolder,
                        value: {
                          id: openFolder,
                          name: folders[openFolder].name,
                          documents: folders[openFolder].documents.filter((id) => id !== doc),
                        },
                      }),
                    );
                  }}
                />
              ))
          : null}
      </Stack>
    </div>
  );
}
